<p-toast position="top-right"></p-toast>
<div class="p-g attendanceViewContainer">
    <div class="p-g-12">
      <p-toolbar>
        <div class="p-toolbar-group-left p-toolbar-tecfolk-fix">
            <p-dialog style="font-weight: 600;" [header]='setLabel("memberAttendanceHeaderLabel")' (onHide)="hideModal()" [(visible)]="trainingAttendanceDialog" class="dialogPop">
                <form #TrainingAttendanceDialogForm="ngForm" style="width: 400px; text-align: inherit;">
                    <div class="displayFlextonDirRTL p-g-12" style="display: flex; align-items: center;">
                        <span class="p-g-4">{{setLabel("markedByLabel")}} </span>
                        <span style="font-weight: 400;">{{this.user.name}}</span>
                    </div>
                    <div class="displayFlextonDirRTL p-g-12">
                        <span class="p-g-4">{{setLabel("memberName:Label")}}</span><span style="font-weight: 400;" class="p-g-8"> {{ member.name }}</span>
                    </div>
                    &nbsp;&nbsp;
                    <p-footer>
                        <button [disabled]="TrainingAttendanceDialogForm.invalid" (click)="markAttendance()" pButton style="top: 23px; margin-left: 118px" type="button" [label]='setLabel("markAttendenceBtnLabel")' icon="pi pi-save" class="p-button-success"></button>
                    </p-footer>
                </form>
            </p-dialog>
            <button routerLink="/attendance" pButton type="button" [label]='setLabel("goBackBtnLabel")' icon="pi pi-arrow-left">
            </button>&nbsp;
        </div>
      </p-toolbar>
    </div>
    <div class="p-g-12">
        <div class="feeDetailsHeader">
            <div class="feeDetailsHeaderField">
                <p class="memberTagText">
                    {{setLabel("membershipNumberLabel")}}
                </p>
                <p>{{member.tagNumber}}</p>
            </div>
            <div class="feeDetailsHeaderField">
                <p class="memberTagText">
                    {{setLabel("nameLabel")}}
                </p>
                <p>{{member.name}}</p>
            </div>
            <div class="feeDetailsHeaderField" *ngIf="member.settings && member.settings.dueDate">
                <p class="memberTagText">
                    {{setLabel("monthlyDueDayLabel")}}
                </p>
                <p>
                    {{member.settings.dueDate | date : "d MMMM"}}
                </p>
            </div>



        </div>
        <div class="card card-w-title">
            <p-panel [header]='setLabel("markAttendenceBtnLabel")' [style]="{'height':'100%','margin-top':'4px'}">
                <full-calendar [events]="events" [options]="scheduleOptions"></full-calendar>
            </p-panel>
        </div>
    </div>
</div>